import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const ContentContainer = styled.div`
  margin: 2em 4em;
  justify-content: space-around;
  padding: 1em;

  & {
    font-size: ${fonts.xSmall};
  }

  > h2 {
    margin-bottom: 1em;
    font-size: ${fonts.large};
  }

  > hr {
    margin: 0;
  }

  && label {
    font-weight: ${fonts.heavy};
  }

  .queue-title-input {
    margin-top: 2em;
  }

  .warning-container {
    padding: 2em 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const ButtonsContainer = styled.div`
  margin-top: 2.75em;
  display: flex;
  width: 50%;
  margin-left: 25%;
  gap: 3em;
  justify-content: center;
`;

export const CancelButton = styled(Button)`
  color: ${colours.elexonBlack};
  background-color: transparent;
  font-weight: ${fonts.normal};
  text-transform: none;
  padding: 0;

  &:hover {
    color: #000;
  }

  &:active {
    box-shadow: none;
  }

  &:focus {
    color: #000;
  }
`;

export const StyledInput = styled.input`
  display: block;
  width: 100%;
  border: 1px solid ${colours.elexonGrey};
  border-radius: 3px;
  font-family: var(--font-family-base);
  font-size: ${fonts.small};
  padding: 10px;
  margin: 0.3em 0;

  &:focus {
    outline: none;
    box-shadow: none;
    border: 1px solid ${colours.elexonBlue};
  }

  &.invalid {
    border: 1px solid ${colours.elexonRed};
    padding-left: 33px;
  }
`;
